import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IModuleBalances } from '../../api/interfaces'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

async function getTotalValuePooledConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_module_balances', timeframe)) as IModuleBalances[]
	const series1 = chartData.map((element: IModuleBalances) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.POOL_MODULE_BALANCE * 2 }
	})
	const series2 = chartData.map((element: IModuleBalances) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.POOL_MODULE_BALANCE_USD * 2 }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'tv pooled [rune]',
			type: 'line',
			seriesGroup: '[rune]',
			color: 'green',
			unitSymbol: 'ᚱ'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'tv pooled [usd]',
			type: 'line',
			seriesGroup: '[usd]',
			color: 'orange',
			unitSymbol: '$'
		}
	]

	return { config: config, latestValue: 0, latestValueDate: 0 }
}

const TotalValuePooled = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getTotalValuePooledConfig, '1m')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Total Value Pooled"
			chartDesc="Total value locked in THORChain liquidity pools."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="56576ba9-906f-4e73-83ef-bc0e4024d752"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
		/>
	)
}

export default TotalValuePooled
